import { render } from "./ak.vue?vue&type=template&id=003569ce&scoped=true"
const script = {}

import "./ak.vue?vue&type=style&index=0&id=003569ce&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003569ce"]])

export default __exports__